
import React, { useMemo, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import "./Blog.css";

export default function BlogList({ posts, onPostClick, navigateTo }) {
  const [activeCategory, setActiveCategory] = useState("all");

  const handlePostClick = (postId) => {
    if (typeof onPostClick === "function") {
      onPostClick(postId);
    }
  };

  const categories = useMemo(() => {
    if (!Array.isArray(posts)) return [];

    return posts
      .map((post) => post.category)
      .filter(Boolean)
      .filter((category, index, array) => array.indexOf(category) === index);
  }, [posts]);

  const filteredPosts = useMemo(() => {
    if (!Array.isArray(posts)) return [];

    if (activeCategory === "all") {
      return posts;
    }

    return posts.filter((post) => post.category === activeCategory);
  }, [posts, activeCategory]);

  const getReadingTime = (post) => {
    const text = `${post.summary || ""} ${post.content || ""}`;
    const words = text.trim().split(/\s+/).filter(Boolean).length;
    const minutes = Math.max(1, Math.ceil(words / 180));

    return `${minutes} دقیقه مطالعه`;
  };

  return (
    <>
      <Header navigateTo={navigateTo} />

      <main className="blog-feed-page">
        <section className="blog-feed-hero">
          <span className="blog-feed-badge">مجله نقش خیال</span>
          <h1> هنر به روایت تصویر </h1>
          <p>
            تازه‌ترین نوشته‌ها درباره سفال، هنرهای دستی، دکوراسیون و پشت‌ صحنه
            دنیای نقش خیال...!
          </p>
        </section>

        <section className="blog-feed-container">
          {Array.isArray(posts) && posts.length > 0 && (
            <div className="blog-category-filter">
              <button
                type="button"
                className={`category-filter-btn ${
                  activeCategory === "all" ? "active" : ""
                }`}
                onClick={() => setActiveCategory("all")}
              >
                همه
              </button>

              {categories.map((category) => (
                <button
                  type="button"
                  key={category}
                  className={`category-filter-btn ${
                    activeCategory === category ? "active" : ""
                  }`}
                  onClick={() => setActiveCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          )}

          {!filteredPosts || filteredPosts.length === 0 ? (
            <div className="no-posts">
              <span>📝</span>
              <p>هیچ پستی یافت نشد.</p>

              {typeof navigateTo === "function" && (
                <button
                  type="button"
                  className="back-to-blog-btn"
                  onClick={() => navigateTo("shop")}
                >
                  بازگشت به صفحه اصلی
                </button>
              )}
            </div>
          ) : (
            <div className="blog-feed-list">
              {filteredPosts.map((post) => (
                <article
                  key={post.id}
                  className="blog-feed-card"
                  onClick={() => handlePostClick(post.id)}
                >
                  <div className="blog-feed-card-header">
                    <div className="blog-author-avatar">
                      {post.author ? post.author.slice(0, 1) : "ن"}
                    </div>

                    <div className="blog-feed-meta-main">
                      <strong>{post.author || "نقش خیال"}</strong>
                      <span>
                        {post.date} · {getReadingTime(post)}
                      </span>
                    </div>

                    {post.category && (
                      <span className="blog-feed-category">
                        {post.category}
                      </span>
                    )}
                  </div>

                  <div className="blog-feed-image">
                    <img
                      src={post.image || "/default-blog.jpg"}
                      alt={post.title}
                      onError={(e) => {
                        e.currentTarget.src = "/default-blog.jpg";
                      }}
                    />
                  </div>

                  <div className="blog-feed-content">
                    <h2>{post.title}</h2>
                    <p>{post.summary}</p>
                  </div>

                  <div className="blog-feed-actions">
                    <button
                      type="button"
                      className="blog-read-more"
                      onClick={(e) => {
                        e.stopPropagation();
                        handlePostClick(post.id);
                      }}
                    >
                      مطالعه بیشتر ←
                    </button>

                    <span className="blog-feed-hint">
                      برای خواندن کامل کلیک کنید
                    </span>
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      </main>

      <Footer navigateTo={navigateTo} />
    </>
  );
}